import { OktaAuth } from "@okta/okta-auth-js";
import { datadogRum } from "@datadog/browser-rum";
import { History } from "history";
import { clearPersistedQueryCache } from "../query/persistedQueryClient";
import { beginLogout, endLogout } from "./logoutState";
import { clearMfaSoftPromptDismissal } from "../utils/helpers/mfaHelpers";

export interface PerformLogoutOptions {
  oktaAuth: OktaAuth;
  history?: History;
  dispatch?: (action: { type: "RESET" }) => void;
  redirectTo?: string;
  onError?: (error: unknown) => void;
}

export async function performLogout({
  oktaAuth,
  history,
  dispatch,
  redirectTo = "/",
  onError,
}: PerformLogoutOptions): Promise<void> {
  beginLogout();
  datadogRum?.clearUser();
  dispatch?.({ type: "RESET" });

  try {
    await clearPersistedQueryCache();
    clearMfaSoftPromptDismissal();
    await oktaAuth.signOut();
    localStorage.clear();

    if (redirectTo === "/") {
      window.location.replace(redirectTo);
      return;
    }

    history?.replace(redirectTo);
  } catch (error) {
    onError?.(error);
    throw error;
  } finally {
    endLogout();
  }
}
